import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import moment from 'moment';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Button, Card, Col, Form, Modal, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import api from 'util/api';
import c from 'util/const';
import enums from 'util/enums';
import idGenerator from 'util/idGenerator';
import logger from 'util/logger';
import segmentHelper from 'helpers/segment-helper';

const IdentificationForm = ({
  signerData,
  witnessId,
  setIdentityItem,
  setShowIdentityForm,
  SelectedIdentification,
  setSelectedIdentification,
  isManualIDSelected,
  setIsColleagues,
  selectedColleague,
  setSelectedColleague,
  isFrom,
  setIsSignerChanged,
  isManualIDSelectedForMarkWitness
}) => {
  const states = c.states;
  const id_picker_opts = [
    {
      name: enums.ID_TYPES.DRIVERS_LICENSE,
      text: enums.ID_TYPES.DRIVERS_LICENSE
    },
    {
      name: enums.ID_TYPES.MILITARY_ID,
      text: enums.ID_TYPES.MILITARY_ID
    },
    {
      name: enums.ID_TYPES.PASSPORT,
      text: enums.ID_TYPES.PASSPORT
    },
    {
      name: enums.ID_TYPES.STATE_ID,
      text: enums.ID_TYPES.STATE_ID
    },
    {
      name: enums.ID_TYPES.OTHER,
      text: enums.ID_TYPES.OTHER
    },
    {
      name: enums.ID_TYPES.NONE,
      text: enums.ID_TYPES.NONE
    }
  ];
  const [identificationData, setIdentificationData] = useState({
    signer_id: signerData?.signer_id,
    witness_id: witnessId,
    identification_id: idGenerator.getIdentificationId(),
    id_first_name:
      isFrom !== 'step4' ? signerData?.signer_first_name || '' : '',
    id_middle_name:
      isFrom !== 'step4' ? signerData?.signer_middle_name || '' : '',
    id_last_name: isFrom !== 'step4' ? signerData?.signer_last_name || '' : '',
    prefix: isFrom !== 'step4' ? signerData?.signer_prefix || '' : '',
    suffix: isFrom !== 'step4' ? signerData?.signer_suffix || '' : '',
    id_type: enums.ID_TYPES.NONE,
    id_type_other: null,
    id_number: null,
    id_issued_date: null,
    id_expiration_date: null,
    date_of_birth: null,
    id_issuing_state: null,
    id_address_1: null,
    id_address_2: null,
    id_city: null,
    id_state: null,
    id_postal_code: null,
    notes: null,
    scan_vendor: null,
    scan_data: null,
    GUID: '',
    IsFavorite: true
  });
  const [isSameIDTypeAsColleagues, setIsSameIDTypeAsColleagues] =
    useState(false);
  const [
    selectedIdentificationofColleague,
    setSelectedIdentificationofColleague
  ] = useState({});
  useEffect(() => {
    setIdentificationData({ ...identificationData, ...SelectedIdentification });
  }, [SelectedIdentification]);
  const [showFullName, setShowFullName] = useState(false);
  // Feature flag for display master client feature
  const features = useSelector(state => state.authentication.features);
  const isMasterClientListEnabled = features.some(
    f => f.name === 'MasterClientList' && f.isEnable === true
  );
  const { signers } = useSelector(state => state.signing);

  useEffect(() => {
    if (isMasterClientListEnabled) {
      // Set selectedColleague from signers
      const collegue = signers.find(
        signer => signer.signer_id === signerData?.signer_id
      );
      if (collegue) {
        api.masterSigner.getByGUID(collegue.GUID, true).then(res => {
          setSelectedColleague(res);
        });
      } else {
        setSelectedColleague({});
      }
    }
  }, []);

  const handleChange = e => {
    if (e?.target?.name == 'IsFavorite') {
      let updateState = {
        ...identificationData,
        [e.target.name]: e.target.checked
      };
      if (!e.target.checked) {
        updateState.existingColleagues = '';
      }
      setIdentificationData(updateState);
    } else {
      setIdentificationData({
        ...identificationData,
        [e.target.name]: e.target.value
      });
    }

    if (selectedColleague && e.target.name === 'id_type') {
      if (selectedColleague?.IdentificationTypes?.includes(e.target.value)) {
        let sameID = selectedColleague?.Identifications?.find(
          item => item.IdType == e.target.value
        );
        setSelectedIdentificationofColleague(sameID);
        setIdentificationData({
          ...identificationData,
          [e.target.name]: e.target.value,
          existingColleagues: sameID.GUID
        });
        setIsSameIDTypeAsColleagues(true);
      } else {
        setIdentificationData({
          ...identificationData,
          [e.target.name]: e.target.value,
          existingColleagues: ''
        });
      }
    }
  };

  const setFormFieldValue = (name, value) => {
    setIdentificationData(identificationData => ({
      ...identificationData,
      // Use moment().format() (ISO-8601), never toString() — the backend
      // DateTime converter rejects JS Date strings like
      // "Sat Sep 08 2018 00:00:00 GMT-0600".
      [name]: moment(value).format()
    }));
  };

  const validateAndSetIdentityItem = () => {
    if (!doValidation()) {
      return;
    }
    let isExistingid_type = signerData?.signerIdentifications?.find(
      item => item.identification.id_type == identificationData.id_type
    );
    let isExistingid_typeWithColleagues = {};
    if (
      selectedColleague?.IdentificationTypes?.includes(
        identificationData.id_type
      )
    ) {
      isExistingid_typeWithColleagues =
        selectedColleague?.Identifications?.find(
          item => item.IdType == identificationData.id_type
        );
    }
    setIdentityItem(identificationData);
    setIsSignerChanged && setIsSignerChanged(true);
    if (isManualIDSelected) {
      segmentHelper.track(
        selectedColleague?.isDocumentWitness
          ? segmentHelper.events
              .MASTER_CLIENT_DOCUMENTWITNESS_MANUAL_ID_SELECTED
          : segmentHelper.events.MASTER_CLIENT_SIGNER_MANUAL_ID_SELECTED
      );
    } else if (isFrom === 'step4' && isManualIDSelectedForMarkWitness) {
      segmentHelper.track(
        segmentHelper.events
          .MASTER_CLIENT_SIGNATUREBYMARKWITNESS_MANUAL_ID_SELECTED
      );
    }
  };

  const doValidation = () => {
    let {
      id_first_name,
      id_last_name,
      id_type,
      id_type_other,
      id_number,
      id_issued_date,
      id_expiration_date,
      date_of_birth,
      id_issuing_state
    } = identificationData;
    let err = [];

    if (id_type === enums.ID_TYPES.NONE) {
      if (id_first_name.length === 0) {
        err.push('Please enter their first name');
      }
      if (id_last_name.length === 0) {
        err.push('Please enter their last name');
      }
    } else {
      if (id_first_name.length === 0) {
        err.push('Please enter their first name');
      }
      if (id_last_name.length === 0) {
        err.push('Please enter their last name');
      }
      if (!id_type) {
        err.push('Please select your identification type');
      } else if (
        id_type === enums.ID_TYPES.OTHER &&
        id_type_other?.length === 0
      ) {
        err.push('Please enter your identification type');
      }
      // if(id_number.length === 0){
      //   err.push('Please enter your identification number');
      // }
      // if (!id_issued_date) {
      //   err.push('Please enter your identification issued date');
      // }
      // if (!id_expiration_date) {
      //   err.push('Please enter your identification expiration date');
      // }
      // if(id_issuing_state.length === 0){
      //   err.push('Please enter your identification issuing state');
      // }
    }

    if (err.length !== 0) {
      toast.warning(err[0], {
        theme: 'colored',
        position: 'bottom-center',
        icon: faExclamationCircle,
        toastId: 'identification-error'
      });
    }
    return err.length === 0;
  };

  useEffect(() => {
    logger.log(identificationData);
  }, [identificationData]);

  const handleColleagueToIdentificationMap = () => {
    let data = {
      prefix: selectedIdentificationofColleague?.Prefix,
      id_first_name: selectedIdentificationofColleague?.FirstName,
      id_middle_name: selectedIdentificationofColleague?.MiddleName,
      id_last_name: selectedIdentificationofColleague?.LastName,
      suffix: selectedIdentificationofColleague?.Suffix,
      id_address_1: selectedIdentificationofColleague?.Address1,
      id_address_2: selectedIdentificationofColleague?.Address2,
      id_city: selectedIdentificationofColleague?.City,
      id_state: selectedIdentificationofColleague?.State,
      id_postal_code: selectedIdentificationofColleague?.PostalCode,
      id_type: selectedIdentificationofColleague?.IdType,
      id_number: selectedIdentificationofColleague?.IdNumber,
      id_issued_date: selectedIdentificationofColleague?.IdIssued,
      id_expiration_date: selectedIdentificationofColleague?.IdExpiration,
      date_of_birth: selectedIdentificationofColleague?.DateOfBirth,
      notes: selectedIdentificationofColleague?.AdditionalData,
      id_type_other: selectedIdentificationofColleague?.IdTypeOther,
      existingColleagues: selectedIdentificationofColleague?.GUID
    };
    setIdentificationData({ ...identificationData, ...data });
  };

  return (
    <Card>
      <FalconCardHeader
        title={
          SelectedIdentification?.identification_id
            ? 'Edit Identification'
            : 'Add Identification'
        }
        endEl={
          <Form.Check
            type="switch"
            id="show-full-name"
            label="Show full name"
            className="form-label-nogutter"
            name="showFullName"
            onChange={() => setShowFullName(!showFullName)}
            checked={showFullName}
          />
        }
      ></FalconCardHeader>
      <Card.Body className="bg-light">
        <Row className="mb-3 g-3">
          {' '}
          {showFullName && (
            <Form.Group as={Col} lg={6} controlId="prefix">
              <Form.Label> Prefix </Form.Label>{' '}
              <Form.Control
                type="text"
                placeholder="Enter prefix name"
                value={identificationData.prefix || ''}
                name="prefix"
                onChange={handleChange}
              />{' '}
            </Form.Group>
          )}
          <Form.Group as={Col} lg={6} controlId="id_first_name">
            <Form.Label> First name * </Form.Label>{' '}
            <Form.Control
              type="text"
              placeholder="Enter first name - (Required)"
              value={identificationData.id_first_name || ''}
              name="id_first_name"
              onChange={handleChange}
            />{' '}
          </Form.Group>
          {showFullName && (
            <Form.Group as={Col} lg={6} controlId="id_middle_name">
              <Form.Label> Middle name </Form.Label>{' '}
              <Form.Control
                type="text"
                placeholder="Enter middle name"
                value={identificationData.id_middle_name || ''}
                name="id_middle_name"
                onChange={handleChange}
              />{' '}
            </Form.Group>
          )}
          <Form.Group as={Col} lg={6} controlId="id_last_name">
            <Form.Label> Last name * </Form.Label>{' '}
            <Form.Control
              type="text"
              placeholder="Enter last name - (Required)"
              value={identificationData.id_last_name || ''}
              name="id_last_name"
              onChange={handleChange}
            />{' '}
          </Form.Group>
          {showFullName && (
            <Form.Group as={Col} lg={6} controlId="suffix">
              <Form.Label> Suffix </Form.Label>{' '}
              <Form.Control
                type="text"
                placeholder="Enter name suffix"
                value={identificationData.suffix || ''}
                name="suffix"
                onChange={handleChange}
              />{' '}
            </Form.Group>
          )}
          <Form.Group as={Col} lg={6} controlId="id_type">
            <Form.Label> ID type </Form.Label>{' '}
            <Form.Select
              type="text"
              name="id_type"
              value={identificationData.id_type || enums.ID_TYPES.NONE}
              onChange={handleChange}
            >
              <option value=""> Select Id Type </option>{' '}
              {id_picker_opts.map(option => {
                const isDisabled = signerData?.signerIdentifications?.some(
                  existing => existing?.identification?.id_type === option.text
                );
                return (
                  <option
                    value={option.text}
                    key={option.text}
                    disabled={isFrom === 'master' ? isDisabled : false}
                  >
                    {' '}
                    {option.name}{' '}
                  </option>
                );
              })}{' '}
            </Form.Select>{' '}
          </Form.Group>
          <Form.Group as={Col} lg={6} controlId="id_number">
            <Form.Label> Identification number </Form.Label>{' '}
            <Form.Control
              type="text"
              placeholder="Enter identification number"
              value={identificationData.id_number || ''}
              name="id_number"
              onChange={handleChange}
            />{' '}
          </Form.Group>
          {identificationData.id_type === enums.ID_TYPES.OTHER && (
            <Form.Group as={Col} lg={12} controlId="id_type_other">
              <Form.Label> ID type name(Other) </Form.Label>{' '}
              <Form.Control
                type="text"
                placeholder="Enter identification number"
                value={identificationData.id_type_other || ''}
                name="id_type_other"
                onChange={handleChange}
              />{' '}
            </Form.Group>
          )}
          <Form.Group as={Col} lg={6} controlId="id_issued_date">
            <Form.Label> ID issue date </Form.Label>{' '}
            <DatePicker
              selected={
                identificationData.id_issued_date
                  ? new Date(identificationData.id_issued_date)
                  : null
              }
              onChange={date => {
                if (date) {
                  setFormFieldValue('id_issued_date', date);
                }
              }}
              className="form-control"
              placeholderText="MM/DD/YYYY"
              dateFormat="MM/dd/yyyy"
              startDate="01/01/1950"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              yearDropdownItemNumber={40}
            />
          </Form.Group>
          <Form.Group as={Col} lg={6} controlId="id_expiration_date">
            <Form.Label> ID expiration date </Form.Label>{' '}
            <DatePicker
              selected={
                identificationData.id_expiration_date
                  ? new Date(identificationData.id_expiration_date)
                  : null
              }
              onChange={date => {
                if (date) {
                  setFormFieldValue('id_expiration_date', date);
                }
              }}
              className="form-control"
              placeholderText="MM/DD/YYYY"
              dateFormat="MM/dd/yyyy"
              startDate="01/01/1950"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              yearDropdownItemNumber={40}
            />
          </Form.Group>
          <Form.Group as={Col} lg={6} controlId="date_of_birth">
            <Form.Label> Date of birth </Form.Label>{' '}
            <DatePicker
              selected={
                identificationData.date_of_birth
                  ? new Date(identificationData.date_of_birth)
                  : null
              }
              onChange={date => {
                if (date) {
                  setFormFieldValue('date_of_birth', date);
                }
              }}
              className="form-control"
              placeholderText="MM/DD/YYYY"
              dateFormat="MM/dd/yyyy"
              startDate="01/01/1950"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              yearDropdownItemNumber={40}
            />
          </Form.Group>
          <Form.Group as={Col} lg={6} controlId="id_address_1">
            <Form.Label> Address line 1 </Form.Label>{' '}
            <Form.Control
              type="text"
              placeholder="Enter address line 1"
              value={identificationData.id_address_1 || ''}
              name="id_address_1"
              onChange={handleChange}
            />{' '}
          </Form.Group>
          <Form.Group as={Col} lg={6} controlId="id_address_2">
            <Form.Label> Address line 2 </Form.Label>{' '}
            <Form.Control
              type="text"
              placeholder="Enter address line 2 - (Optional)"
              value={identificationData.id_address_2 || ''}
              name="id_address_2"
              onChange={handleChange}
            />{' '}
          </Form.Group>
          <Form.Group as={Col} lg={6} controlId="id_city">
            <Form.Label> City </Form.Label>{' '}
            <Form.Control
              type="text"
              placeholder="Enter city name"
              value={identificationData.id_city || ''}
              name="id_city"
              onChange={handleChange}
            />{' '}
          </Form.Group>
          <Form.Group as={Col} lg={6} controlId="id_state">
            <Form.Label> State </Form.Label>{' '}
            <Form.Select
              type="text"
              name="id_state"
              value={identificationData.id_state || ''}
              onChange={handleChange}
            >
              <option value=""> Select state </option>{' '}
              {states.map(option => (
                <option value={option.text} key={option.text}>
                  {' '}
                  {option.name}{' '}
                </option>
              ))}{' '}
            </Form.Select>{' '}
          </Form.Group>
          <Form.Group as={Col} lg={6} controlId="id_postal_code">
            <Form.Label> Postal code </Form.Label>{' '}
            <Form.Control
              type="text"
              placeholder="Enter postal code"
              value={identificationData.id_postal_code || ''}
              name="id_postal_code"
              onChange={handleChange}
            />{' '}
          </Form.Group>
          <Form.Group as={Col} lg={12} controlId="notes">
            <Form.Label> Notes </Form.Label>{' '}
            <Form.Control
              as="textarea"
              rows={2}
              type="text"
              placeholder="Enter identification Notes (Optional)"
              value={identificationData.notes || ''}
              name="notes"
              onChange={handleChange}
            />{' '}
          </Form.Group>
          {isManualIDSelected && (
            <Form.Group as={Col} lg={12} controlId="IsFavorite">
              <Form.Label>Add ID to client's profile</Form.Label>
              <Form.Check
                type="switch"
                id="IsFavorite"
                name="IsFavorite"
                className="pull-right"
                label=""
                size={'md'}
                onChange={e => handleChange(e, e.target.checked)}
                checked={identificationData.IsFavorite}
              />
            </Form.Group>
          )}
          <hr />
          <Flex justifyContent="center">
            <Button
              className="mx-1"
              variant="secondary"
              onClick={() => {
                setShowIdentityForm(false);
                setSelectedIdentification({});
              }}
            >
              Close{' '}
            </Button>{' '}
            <Button
              variant="primary"
              onClick={() => validateAndSetIdentityItem()}
            >
              {' '}
              Save{' '}
            </Button>{' '}
          </Flex>{' '}
          {/* notify while same id selected colleagues */}
          <Modal
            show={isSameIDTypeAsColleagues}
            onHide={() =>
              setIsSameIDTypeAsColleagues(!isSameIDTypeAsColleagues)
            }
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                Duplicate Identification
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="my-2">
                This ID has already been assigned to a colleague. Saving this ID
                will override the existing identification data.
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-end">
                <Button
                  variant="primary"
                  className="mx-1"
                  onClick={() => {
                    setIsSameIDTypeAsColleagues(!isSameIDTypeAsColleagues);
                    handleColleagueToIdentificationMap();
                  }}
                >
                  Acknowledge
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        </Row>
      </Card.Body>
    </Card>
  );
};
export default IdentificationForm;
